module.exports = __webpack_public_path__ + "static/media/financial.e6357413.svg";